import React, { useState } from 'react';
import './PrivacyPolicy.css';
import Footer from '../../compos/Footer/Footer';
import Header from '../../compos/Header/Header';

const LegalDocuments = () => {
	const [activeTab, setActiveTab] = useState('privacy'); // 'privacy' or 'eula'

	return (
		<div className='privacy-scroll-point d-flex flex-column justify-content-between'>
			<Header />
			<section className='text-start m-5'>
				{/* Tab Navigation */}
				<div className='d-flex mb-4'>
					<button
						className={`btn ${activeTab === 'privacy' ? 'btn-primary' : 'btn-outline-primary'} me-2`}
						onClick={() => setActiveTab('privacy')}
					>
						Privacy Policy
					</button>
					<button
						className={`btn ${activeTab === 'eula' ? 'btn-primary' : 'btn-outline-primary'}`}
						onClick={() => setActiveTab('eula')}
					>
						End User License Agreement
					</button>
				</div>

				{/* Privacy Policy Content */}
				{activeTab === 'privacy' && (
					<div className='privacy-text'>
						<h1>Privacy Policy</h1>
						<p>Last updated: March 05, 2024</p>
						<p>
							This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your
							information when You use the Service and tells You about Your privacy rights and how the law protects You.
						</p>
						<h2>Interpretation and Definitions</h2>
						<h3>Interpretation</h3>
						<p>
							The words of which the initial letter is capitalized have meanings defined under the following conditions.
							The following definitions shall have the same meaning regardless of whether they appear in singular or in
							plural.
						</p>
						<h3>Definitions</h3>
						<p>For the purposes of this Privacy Policy:</p>
						<ul className='custom-list'>
							<li>
								<strong>Account</strong> means a unique account created for You to access our Service or parts of our
								Service.
							</li>
							<li>
								<strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control
								with a party, where "control" means ownership of 50% or more of the shares, equity interest or other
								securities entitled to vote for election of directors or other managing authority.
							</li>
							<li>
								<strong>Application</strong> refers to MyNews, MyReport, the software program provided by the Company.
							</li>
							<li>
								<strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement)
								refers to B-reporter.
							</li>
							<li>
								<strong>Country</strong> refers to: Delhi, India.
							</li>
							<li>
								<strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or
								a digital tablet.
							</li>
							<li>
								<strong>Personal Data</strong> is any information that relates to an identified or identifiable
								individual.
							</li>
							<li>
								<strong>Service</strong> refers to the Application.
							</li>
							<li>
								<strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of
								the Company. It refers to third-party companies or individuals employed by the Company to facilitate the
								Service, to provide the Service on behalf of the Company, to perform services related to the Service or
								to assist the Company in analyzing how the Service is used.
							</li>
							<li>
								<strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the
								Service or from the Service infrastructure itself (for example, the duration of a page visit).
							</li>
							<li>
								<strong>You</strong> means the individual accessing or using the Service, or the company, or other legal
								entity on behalf of which such individual is accessing or using the Service, as applicable.
							</li>
						</ul>
						<br />
						<h2>Collecting and Using Your Personal Data</h2>
						<h3>Types of Data Collected</h3>
						<h4>Personal Data</h4>
						<p>
							While using Our Service, We may ask You to provide Us with certain personally identiFiable information
							that can be used to contact or identify You. Personally identiFiable information may include, but is not
							limited to:
						</p>
						<ul className='custom-list'>
							<li>Email address</li>
							<li>First name and last name Phone</li>
							<li>number</li>
							<li>Address, State, Province, ZIP/Postal code, City Usage</li>
							<li>Data</li>
						</ul>
						<h4>Usage Data</h4>
						<p>Usage Data is collected automatically when using the Service.</p>
						<p>
							Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address),
							browser type, browser version, the pages of our Service that You visit, the time and date of Your visit,
							the time spent on those pages, unique device identiFiers and other diagnostic data.
						</p>
						<p>
							When You access the Service by or through a mobile device, We may collect certain information
							automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique
							ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet
							browser You use, unique device identiFiers and other diagnostic data.
						</p>
						<p>
							We may also collect information that Your browser sends whenever You visit our Service or when You access
							the Service by or through a mobile device.
						</p>
						<h4>Information Collected while Using the Application</h4>
						<p>
							While using Our Application, in order to provide features of Our Application, We may collect, with Your
							prior permission:
						</p>
						<ul className='custom-list'>
							<li> Information regarding your location</li>
							<li>Pictures and other information from your Device's camera and photo library</li>
						</ul>
						<p>
							We use this information to provide features of Our Service, to improve and customize Our Service. The
							information may be uploaded to the Company's servers and/or a Service Provider's server or it may be
							simply stored on Your device.
						</p>
						<p>You can enable or disable access to this information at any time, through Your Device settings.</p>
						<h4>Use of Your Personal Data</h4>
						<p>The Company may use Personal Data for the following purposes:</p>
						<ul className='custom-list'>
							<li>
								<strong>To provide and maintain our Service,</strong> including to monitor the usage of our Service.
							</li>
							<li>
								<strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The
								Personal Data You provide can give You access to different functionalities of the Service that are
								available to You as a registered user.
							</li>
							<li>
								<strong>For the performance of a contract:</strong> the development, compliance and undertaking of the
								purchase contract for the products, items or services You have purchased or of any other contract with
								Us through the Service.
							</li>
							<li>
								<strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent
								forms of electronic communication, such as a mobile application's push notifications regarding updates
								or informative communications related to the functionalities, products or contracted services, including
								the security updates, when necessary or reasonable for their implementation.
							</li>
							<li>
								<strong>To provide You</strong> with news, special offers and general information about other goods,
								services and events which we offer that are similar to those that you have already purchased or enquired
								about unless You have opted not to receive such information.
							</li>
							<li>
								<strong>To manage Your requests:</strong> To attend and manage Your requests to Us.
							</li>
							<li>
								<strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger,
								divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our
								assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in
								which Personal Data held by Us about our Service users is among the assets transferred.
							</li>
							<li>
								<strong>For other purposes:</strong> We may use Your information for other purposes, such as data
								analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to
								evaluate and improve our Service, products, services, marketing and your experience.
							</li>
						</ul>
						<br />
						We may share Your personal information in the following situations:
						<ul className='custom-list'>
							<li>
								<strong>With Service Providers:</strong> We may share Your personal information with Service Providers
								to monitor and analyze the use of our Service, to contact You.
							</li>
							<li>
								<strong>For business transfers:</strong> We may share or transfer Your personal information in
								connection with, or during negotiations of, any merger, sale of Company assets, Financing, or
								acquisition of all or a portion of Our business to another company.
							</li>
							<li>
								<strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we
								will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and
								any other subsidiaries, joint venture partners or other companies that We control or that are under
								common control with Us.
							</li>
							<li>
								<strong>With business partners:</strong> We may share Your information with Our business partners to
								offer You certain products, services or promotions.
							</li>
							<li>
								<strong>With other users:</strong> when You share personal information or otherwise interact in the
								public areas with other users, such information may be viewed by all users and may be publicly
								distributed outside.
							</li>
							<li>
								<strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with
								Your consent.
							</li>
						</ul>
						<br />
						<h4>Retention of Your Personal Data</h4>
						<p>
							The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in
							this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our
							legal obligations (for example, if we are required to retain your data to comply with applicable laws),
							resolve disputes, and enforce our legal agreements and policies.
						</p>
						<p>
							The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained
							for a shorter period of time, except when this data is used to strengthen the security or to improve the
							functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
						</p>
						<h4>Transfer of Your Personal Data</h4>
						<p>
							Your information, including Personal Data, is processed at the Company's operating ofFices and in any
							other places where the parties involved in the processing are located. It means that this information may
							be transferred to — and maintained on — computers located outside of Your state, province, country or
							other governmental jurisdiction where the data protection laws may differ than those from Your
							jurisdiction.
						</p>
						<p>
							Your consent to this Privacy Policy followed by Your submission of such information represents Your
							agreement to that transfer.
						</p>
						<p>
							The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in
							accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an
							organization or a country unless there are adequate controls in place including the security of Your data
							and other personal information.
						</p>
						<h4>Delete Your Personal Data</h4>
						<p>
							You have the right to delete or request that We assist in deleting the Personal Data that We have
							collected about you.
						</p>
						<p>Our Service may give You the ability to delete certain information about You from within the Service.</p>
						<p>
							You may update, amend, or delete Your information at any time by signing in to Your Account, if you have
							one, and visiting the account settings section that allows you to manage Your personal information. You
							may also contact Us to request access to, correct, or delete any personal information that You have
							provided to Us.
						</p>
						<p>
							Please note, however, that We may need to retain certain information when we have a legal obligation or
							lawful basis to do so.
						</p>
						<h4>Disclosure of Your Personal Data</h4>
						<h5>Business Transactions</h5>
						<p>
							If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred.
							We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy
							Policy.
						</p>
						<h5>Law enforcement</h5>
						<p>
							Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do
							so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
						</p>
						<h5>Other legal requirements</h5>
						<p>
							The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
						</p>
						<ul className='custom-list'>
							<li> Comply with a legal obligation</li>
							<li> Protect and defend the rights or property of the Company</li>
							<li> Prevent or investigate possible wrongdoing in connection with the Service</li>
							<li> Protect the personal safety of Users of the Service or the public</li>
							<li> Protect against legal liability</li>
						</ul>
						<br />
						<h4>Security of Your Personal Data</h4>
						<p>
							The security of Your Personal Data is important to Us, but remember that no method of transmission over
							the Internet, or method of electronic storage is 100% secure. While We strive to use commercially
							acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
						</p>
						<h4>Children's Privacy</h4>
						<p>
							Our Service does not address anyone under the age of 13. We do not knowingly collect personally
							identiFiable information from anyone under the age of 13. If You are a parent or guardian and You are
							aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We
							have collected Personal Data from anyone under the age of 13 without veriFication of parental consent, We
							take steps to remove that information from Our servers
						</p>
						<p>
							If We need to rely on consent as a legal basis for processing Your information and Your country requires
							consent from a parent, We may require Your parent's consent before We collect and use that information.
						</p>
						<h4>Links to Other Websites</h4>
						<p>
							Our Service may contain links to other websites that are not operated by Us. If You click on a third party
							link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy
							of every site You visit.
						</p>
						<p>
							We have no control over and assume no responsibility for the content, privacy policies or practices of any
							third party sites or services.
						</p>
						<h4>Changes to this Privacy Policy</h4>
						<p>
							We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new
							Privacy Policy on this page.
						</p>
						<p>
							We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming
							effective and update the "Last updated" date at the top of this Privacy Policy.
						</p>
						<p>
							You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy
							are effective when they are posted on this page.
						</p>
						<h4>Contact Us</h4>
						<p>If you have any questions about this Privacy Policy, You can contact us:</p>
						<ul className='custom-list'>
							<li>By email: breporter.services@gmail.com</li>
						</ul>
						<br />
					</div>
				)}

				{/* EULA Content */}
				{activeTab === 'eula' && (
					<div className='privacy-text'>
						<h1>End User License Agreement (EULA)</h1>
						<p>Last updated: April 23, 2025</p>
						<p>
							This End User License Agreement ("Agreement") is a binding legal agreement between you ("End User" or
							"You") and B-Reporter ("Company", "We", "Us" or "Our"), governing your use of the MyNews, MyReport
							software application and related services (collectively, the "Application").
						</p>

						<p>By downloading, installing, accessing, or using the Application, you:</p>
						<ul className='custom-list'>
							<li>Acknowledge that you have read and understand this Agreement;</li>
							<li>Represent that you are of legal age to enter into a binding agreement; and</li>
							<li>Accept this Agreement and agree to be legally bound by its terms.</li>
						</ul>

						<p>If you do not agree to these terms, do not download, install, access, or use the Application.</p>

						<h2>1. LICENSE GRANT</h2>
						<p>
							Subject to the terms of this Agreement, the Company grants you a limited, non-exclusive, non-transferable,
							revocable license to:
						</p>
						<ul className='custom-list'>
							<li>
								Download, install, and use the Application on devices that you own or control for your personal,
								non-commercial use.
							</li>
							<li>
								Access and use the Application in accordance with this Agreement and any applicable usage rules set
								forth by the application store from which you obtained the Application.
							</li>
						</ul>

						<h2>2. LICENSE RESTRICTIONS</h2>
						<p>You agree NOT to:</p>
						<ul className='custom-list'>
							<li>Copy, modify, or create derivative works based on the Application;</li>
							<li>Distribute, publicly display, publicly perform, or sublicense the Application;</li>
							<li>
								Reverse engineer, decompile, disassemble, or attempt to derive the source code of the Application;
							</li>
							<li>
								Remove, circumvent, disable, damage, or otherwise interfere with security-related features of the
								Application;
							</li>
							<li>
								Use the Application in any manner that could damage, disable, overburden, or impair the Application
								servers or networks;
							</li>
							<li>Use automated scripts to collect information from or otherwise interact with the Application;</li>
							<li>Use the Application for any illegal or unauthorized purpose;</li>
							<li>
								Violate any applicable laws, rules, or regulations in connection with your access or use of the
								Application.
							</li>
						</ul>

						<h2>3. INTELLECTUAL PROPERTY RIGHTS</h2>
						<p>
							The Application, including all content, features, and functionality, is owned by the Company and its
							licensors and is protected by India and international copyright, trademark, patent, trade secret, and
							other intellectual property or proprietary rights laws.
						</p>

						<h2>4. USER CONTENT</h2>
						<h3>4.1 User Content Definition</h3>
						<p>
							"User Content" means any content that you submit, post, or transmit through the Application, including
							text, images, audio, and video.
						</p>

						<h3>4.2 License to User Content</h3>
						<p>
							By submitting User Content through the Application, you grant the Company a worldwide, non-exclusive,
							royalty-free, sublicensable, and transferable license to use, reproduce, distribute, prepare derivative
							works of, display, perform, and otherwise exploit your User Content in connection with the Application and
							the Company's business.
						</p>

						<h3>4.3 User Content Representations</h3>
						<p>You represent and warrant that:</p>
						<ul className='custom-list'>
							<li>You own or have the necessary rights to submit User Content;</li>
							<li>
								The User Content does not infringe the intellectual property rights or any other rights of any third
								party;
							</li>
							<li>The User Content complies with all applicable laws and regulations.</li>
						</ul>

						<h2>5. THIRD-PARTY SERVICES AND CONTENT</h2>
						<h3>5.1 Third-Party Services</h3>
						<p>
							The Application may display, include, or make available third-party content or provide links to
							third-party websites or services. You acknowledge that the Company is not responsible for third-party
							content, websites, or services.
						</p>

						<h3>5.2 Third-Party Terms</h3>
						<p>
							Your use of such third-party services may be subject to additional terms and conditions provided by the
							third party. This Agreement does not affect your legal relationship with these third parties.
						</p>

						<h2>6. PRIVACY POLICY</h2>
						<p>
							Your use of the Application is also governed by our Privacy Policy, which is incorporated by reference
							into this Agreement.
						</p>

						<h2>7. UPDATES AND MODIFICATIONS</h2>
						<h3>7.1 Application Updates</h3>
						<p>
							The Company may from time to time provide enhancements or improvements to the features/functionality of
							the Application, which may include patches, bug fixes, updates, upgrades, and other modifications
							("Updates"). Updates may modify or delete certain features and/or functionalities of the Application.
						</p>

						<h3>7.2 Automatic Updates</h3>
						<p>
							You agree that the Company has no obligation to provide Updates or to continue to provide or enable any
							particular features and/or functionalities of the Application. You further agree that all Updates will be
							deemed part of the Application and be subject to all terms and conditions of this Agreement.
						</p>

						<h3>7.3 Agreement Modifications</h3>
						<p>
							The Company reserves the right to modify this Agreement at any time. If we make changes, we will provide
							notice, such as by sending an email, providing a notice through the Application, or updating the "Last
							Updated" date at the top of this Agreement. Your continued use of the Application after such notice
							constitutes your acceptance of the modified Agreement.
						</p>

						<h2>8. TERM AND TERMINATION</h2>
						<h3>8.1 Term</h3>
						<p>This Agreement remains in effect until terminated by you or the Company.</p>

						<h3>8.2 Termination by You</h3>
						<p>
							You may terminate this Agreement by uninstalling the Application from all devices in your possession or
							control.
						</p>

						<h3>8.3 Termination by Company</h3>
						<p>
							The Company may terminate this Agreement at any time without notice if you fail to comply with any term of
							this Agreement. The Company may also terminate or suspend your access to the Application at any time,
							without notice and in its sole discretion.
						</p>

						<h3>8.4 Effect of Termination</h3>
						<p>
							Upon termination of this Agreement, your license to use the Application will terminate and you must cease
							all use of the Application. Sections 2, 3, 4, 9, 10, 11, 12, 13, and 14 will survive termination.
						</p>

						<h2>9. DISCLAIMER OF WARRANTIES</h2>
						<p>
							THE APPLICATION IS PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT WARRANTY OF ANY KIND. THE COMPANY
							EXPRESSLY DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING THE WARRANTIES OF
							MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
						</p>

						<p>
							THE COMPANY MAKES NO WARRANTY THAT: (A) THE APPLICATION WILL MEET YOUR REQUIREMENTS; (B) THE APPLICATION
							WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE; (C) THE RESULTS FROM THE USE OF THE APPLICATION WILL
							BE ACCURATE OR RELIABLE; OR (D) ANY ERRORS IN THE APPLICATION WILL BE CORRECTED.
						</p>

						<h2>10. LIMITATION OF LIABILITY</h2>
						<p>
							TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE COMPANY BE LIABLE FOR ANY
							INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES, OR ANY DAMAGES WHATSOEVER INCLUDING,
							WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, DATA, OR PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED WITH
							THE USE OR PERFORMANCE OF THE APPLICATION, WITH THE DELAY OR INABILITY TO USE THE APPLICATION, OR FOR ANY
							INFORMATION, SOFTWARE, PRODUCTS, SERVICES OBTAINED THROUGH THE APPLICATION, OR OTHERWISE ARISING OUT OF
							THE USE OF THE APPLICATION, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE,
							EVEN IF THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES.
						</p>

						<p>
							IN ANY EVENT, THE COMPANY'S TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION (WHETHER
							IN CONTRACT, TORT, OR OTHERWISE) SHALL NOT EXCEED THE AMOUNT PAID BY YOU, IF ANY, FOR ACCESSING OR USING
							THE APPLICATION.
						</p>

						<h2>11. INDEMNIFICATION</h2>
						<p>
							You agree to indemnify, defend, and hold harmless the Company and its officers, directors, employees,
							agents, affiliates, successors, and assigns from and against any and all losses, damages, liabilities,
							deficiencies, actions, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of
							whatever kind, including reasonable attorneys' fees, arising from or relating to: (a) your use of the
							Application; (b) your User Content; (c) your violation of this Agreement; or (d) your violation of any
							rights of another party.
						</p>

						<h2>12. EXPORT REGULATIONS</h2>
						<p>
							The Application may be subject to export control laws. You shall not, directly or indirectly, export,
							re-export, or release the Application to, or make the Application accessible from, any jurisdiction or
							country to which export, re-export, or release is prohibited by law, rule, or regulation.
						</p>

						<h2>13. GOVERNING LAW AND JURISDICTION</h2>
						<p>
							This Agreement is governed by and construed in accordance with the laws of Delhi, India, without giving
							effect to any choice of law or conflict of law provisions. Any legal suit, action, or proceeding arising
							out of or related to this Agreement or the Application shall be instituted exclusively in the courts
							located in Delhi, India.
						</p>

						<h2>14. GENERAL PROVISIONS</h2>
						<h3>14.1 Entire Agreement</h3>
						<p>
							This Agreement and our Privacy Policy constitute the entire agreement between you and the Company
							regarding the Application and supersede all prior and contemporaneous agreements, proposals, or
							representations, written or oral, concerning its subject matter.
						</p>

						<h3>14.2 Waiver</h3>
						<p>
							No failure or delay by the Company in exercising any right under this Agreement shall constitute a waiver
							of that right.
						</p>

						<h3>14.3 Severability</h3>
						<p>
							If any provision of this Agreement is held by a court of competent jurisdiction to be unenforceable, such
							provision shall be modified to the minimum extent necessary to make it enforceable and the remaining
							provisions of this Agreement will remain in full force and effect.
						</p>

						<h3>14.4 Assignment</h3>
						<p>
							You may not assign this Agreement without the prior written consent of the Company. The Company may assign
							this Agreement without restriction.
						</p>

						<h3>14.5 Contact Information</h3>
						<p>If you have any questions about this Agreement, please contact us at:</p>
						<ul className='custom-list'>
							<li>Email: breporter.services@gmail.com</li>
						</ul>
						<br />
						<p>
							<strong>Copyright © 2025 B-Reporter. All rights reserved</strong>
						</p>
						<p>
							C/O Vision cowork, Kh. No. 293 S/F, Western Marg, Saidulajab, Near Kher Singh Estate, Saket, New Delhi -
							110030
						</p>
					</div>
				)}
			</section>
			<Footer />
		</div>
	);
};

export default LegalDocuments;
